import { getStorageItem, setStorageItem } from './localStorage'

/**
 * Delete cookies by setting the expire date to the past
 */
export const deleteCookies = () => {
  const cookies = document.cookie.split(';')
  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  })
}

/**
 * Renew the version of lidarmill by removing any data in local storage
 * and setting a new version of lidarmill
 */
export const renewVersion = () => {
  deleteCookies()
  // localStorage.removeItem('persist:root')
  setStorageItem('lidarmillVersion', process.env.REACT_APP_LIDARMILL_VERSION)
}

/**
 * Checks the version of the lidarmill frontend
 * @param {func} callback Some callback function
 */
export const checkVersion = callback => {
  const lidarmillVersion = getStorageItem('lidarmillVersion')
  if (process.env.REACT_APP_LIDARMILL_VERSION !== lidarmillVersion) {
    renewVersion()
  }
  if (typeof callback === 'function') callback()
}
